import { gql } from "apollo-boost";

export const statusSistemaQueries = gql`
query StatusSistemaQueries ($today: String )  {
    statusSessoesAtuais {
        nomeOrganizador
        nomeSessao
        qtdUsuariosConectados
        qtdTotalUsuariosConectados
        qtdTotalSessoesConectados
    }
    statusRecursosUtilizados {
        title
        value
        color
    }
    statusHistoricoHoje ( today: $today )  {
        horario
        sessoesExecucao
        usuariosConectados
    }
}`;
